import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";

/**
 * Password gate for the admin area. Owns only its local form state and
 * delegates verification to the `onLogin` callback (returns a boolean).
 */
export const AdminLogin = ({ onLogin }) => {
  const [pw, setPw] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pw.trim()) return;
    setLoggingIn(true);
    try {
      const ok = await onLogin(pw);
      if (ok) setPw("");
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[var(--bg)] px-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <span className="font-heading text-2xl font-bold text-[var(--ink)]">
            Procur<span className="text-[var(--blue)]">mo</span>
          </span>
          <p className="mt-1 text-sm text-[var(--slate)]">Admin · Warteliste</p>
        </div>
        <form
          onSubmit={handleSubmit}
          data-testid="admin-login-form"
          className="rounded-2xl border border-[var(--border)] bg-white p-6 shadow-lg-soft"
        >
          <div className="mb-4 flex items-center gap-2 text-[var(--ink)]">
            <span className="grid h-9 w-9 place-items-center rounded-xl bg-[var(--blue-soft)] text-[var(--blue)]">
              <Lock className="h-4 w-4" strokeWidth={1.8} />
            </span>
            <div>
              <div className="text-sm font-semibold">Geschützter Bereich</div>
              <div className="text-xs text-[var(--slate)]">Bitte Admin-Passwort eingeben</div>
            </div>
          </div>
          <Label htmlFor="admin-pw" className="text-xs font-medium text-[var(--ink)]">Passwort</Label>
          <Input
            id="admin-pw"
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="••••••••••"
            autoFocus
            data-testid="admin-password-input"
            className="mt-1.5"
          />
          <Button
            type="submit"
            disabled={loggingIn || !pw.trim()}
            data-testid="admin-login-button"
            className="mt-4 w-full bg-[var(--blue)] text-white hover:bg-[var(--blue-2)]"
          >
            {loggingIn ? <Loader2 className="h-4 w-4 animate-spin" /> : "Anmelden"}
          </Button>
        </form>
        <div className="mt-4 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-xs font-medium text-[var(--slate)] transition-colors hover:text-[var(--blue)]"
            data-testid="admin-back-link"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> Zurück zur Website
          </Link>
        </div>
      </div>
    </div>
  );
};
